import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

/** Pages for partner team members only; everyone else is sent to the User Explorer. */
export const Route = createFileRoute('/_app/_partner')({
  beforeLoad: ({ context }) => {
    if (context.role.kind !== 'partner') {
      throw redirect({ to: '/' })
    }
  },
  component: () => <Outlet />,
})
